import { render, staticRenderFns } from "./Registro.vue?vue&type=template&id=ded7f1ee&scoped=true"
import script from "./Registro.vue?vue&type=script&lang=ts"
export * from "./Registro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded7f1ee",
  null
  
)

export default component.exports